#include<Position>

void main(void) {
    vUV = uv;

    gl_Position = getVertexPosition();
}